import React from "react";
import SectionHeader from "./SectionHeader";
import { fileInformation } from "./constant";

function FileInformation({
  
  onChange = () => {},
 
  formData,
  labelClass,
  inputClass,
  carrierBookingNumber,
  fileNumber,
  customerReference,
}) {
  return (
    <div className=" rounded border border-slate-200 dark:border-slate-700 overflow-hidden">
      
        <div className="p-4">
          <div className="grid grid-cols-4 gap-4">
            {fileInformation &&
              fileInformation.map((field) => {
                return (
                  <div>
                    <label className={labelClass}>{field.label}</label>
                    <input
                      type="text"
                      className={inputClass}
                      value={
                        field.name === "fileNumber"
                          ? fileNumber
                          : field.name === "customerReference"
                            ? customerReference
                            : formData?.[field.name]
                      }
                      name={field.name}
                      disabled={field?.disabled}
                      onChange={(e) =>
                        onChange(field.name, e.target.value, field?.type)
                      }
                    />
                  </div>
                );
              })}

            <div>
              <label className={labelClass}>Carrier Booking Number:</label>
              <input
                type="text"
                className={inputClass}
                value={carrierBookingNumber}
                name={"carrierBookingNumber"}
                disabled={true}
              />
            </div>
          </div>
        </div>
      
    </div>
  );
}

export default FileInformation;
